import { render, staticRenderFns } from "./BrandPartsEditLayer.vue?vue&type=template&id=d9365d32&scoped=true&"
import script from "./BrandPartsEditLayer.vue?vue&type=script&lang=js&"
export * from "./BrandPartsEditLayer.vue?vue&type=script&lang=js&"
import style0 from "./BrandPartsEditLayer.vue?vue&type=style&index=0&id=d9365d32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9365d32",
  null
  
)

export default component.exports